import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../domains/auth/contexts/AuthContext';
import { hasFullPlatformStaffStatus } from '../domains/auth/teacherAccess';

const StaffHome: React.FC = () => {
  const { userData } = useAuth();

  const staffStatus =
    userData?.role === 'teacher'
      ? (userData.staffStatus ?? 'active')
      : null;

  const title =
    staffStatus === 'applicant'
      ? 'Welcome — complete your onboarding'
      : staffStatus === 'offboarded'
        ? 'Account offboarded'
        : 'Welcome';

  const body =
    staffStatus === 'applicant'
      ? 'Your teacher account is in applicant status. Accept your offer (if you haven’t yet), sign your contract, and work through the onboarding checklist to become Overture Certified to teach.'
      : staffStatus === 'offboarded'
        ? 'Your staff account has been offboarded. If you believe this is a mistake, please contact an administrator.'
        : 'You have access to the full platform.';

  return (
    <div style={{ padding: '2rem', maxWidth: 780 }}>
      <h1 style={{ margin: 0, fontSize: '2rem' }}>{title}</h1>
      <p style={{ marginTop: '0.75rem', fontSize: '1.05rem', lineHeight: 1.5 }}>
        {body}
      </p>

      {userData?.role === 'teacher' && staffStatus === 'applicant' && (
        <Link
          to="/app/onboarding"
          style={{
            display: 'inline-block',
            marginTop: '1.25rem',
            background: '#0288D1',
            color: '#fff',
            textDecoration: 'none',
            padding: '12px 16px',
            borderRadius: 10,
            fontWeight: 700,
          }}
        >
          Open onboarding &amp; certifications →
        </Link>
      )}

      {userData?.role === 'teacher' && staffStatus && !hasFullPlatformStaffStatus(staffStatus) && (
        <div
          style={{
            marginTop: '1.25rem',
            padding: '1rem',
            borderRadius: 12,
            background: 'rgba(2, 136, 209, 0.08)',
            border: '1px solid rgba(2, 136, 209, 0.18)',
          }}
        >
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Status</div>
          <div style={{ fontFamily: 'monospace' }}>{staffStatus}</div>
        </div>
      )}
    </div>
  );
};

export default StaffHome;



